<template>
  <div></div>
</template>
<script>
import { useStore } from 'vuex'

import { useRoutRedirect } from '@/hooks/use-rout-redirect'

export default {
  name: 'Home',
  setup() {
    const store = useStore()
    const { routRedirect } = useRoutRedirect()
    const role = store.state.globalComponents.role
    const userId = store.state.globalComponents.clientId

    console.log('[Home] Component mounted')
    console.log('[Home] isAuth:', store.state.auth.isAuth)
    console.log('[Home] role:', role)
    console.log('[Home] userId:', userId)
    console.log('[Home] permissions:', store.state.globalComponents?.permissions)

    if (store.state.auth.isAuth && role) {
      console.log('[Home] Calling routRedirect with role:', role, 'userId:', userId)
      routRedirect({ role, userId })
    } else {
      console.warn('[Home] Not redirecting. isAuth:', store.state.auth.isAuth, 'role:', role)
    }
  },
}
</script>
